import { useEffect, useState } from "react";
import CreateEditProcessForm from "@via/pages/projects/pipelines/workflow/components/create-edit-process-form/create-edit-process-form.tsx";
import {
  createEmptyProcess,
  packProcessToSave,
} from "@via/pages/projects/pipelines/workflow/utils/helpers.tsx";
import { useCreateModelSkill } from "@via/pages/cortex/model-skill/model-skill.api.tsx";
import { CreateModelSkillRequestBody, MenuGroupType } from "common";

interface CreateModelSkillFormProps {
  setOpen: (open: boolean) => void;
}

const CreateModelSkillForm = ({ setOpen }: CreateModelSkillFormProps) => {
  const [initialData] = useState(() => {
    const emptyProcess = createEmptyProcess();
    return {
      ...emptyProcess,
      type: MenuGroupType.MODEL_SKILL.toString(),
    };
  });

  const {
    mutateAsync: createModelSkill,
    isPending: isCreateModelSkillLoading,
    isSuccess: isCreateModelSkillSuccess,
  } = useCreateModelSkill();

  useEffect(() => {
    if (isCreateModelSkillSuccess) {
      setOpen(false);
    }
  }, [isCreateModelSkillSuccess, setOpen]);

  const handleSaveProcess = async (processDraft: any) => {
    try {
      // Transform process data using packProcessToSave
      const processData = packProcessToSave(processDraft);

      // Create the model skill payload
      const payload: CreateModelSkillRequestBody = {
        process: processData,
      };

      await createModelSkill(payload);
    } catch (error) {
      // Error handling is done in the mutation hook
      console.error("Failed to create model skill:", error);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <CreateEditProcessForm
      title="Create Model Skill"
      data={initialData}
      isCreateProcessRevisionLoading={false}
      isOverwriteRevisionLoading={false}
      isCreateNewProcessLoading={isCreateModelSkillLoading}
      onSaveProcess={handleSaveProcess}
      onChangeRevision={() => {}}
      onOverwriteProcess={() => {}}
      onDuplicateProcess={() => {}}
      onCancel={handleCancel}
    />
  );
};

export default CreateModelSkillForm;
